function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.006 10A2 2 0 0010 11.992v11.016A1.992 1.992 0 0012.006 25H17V10z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 10v15h4.994A2 2 0 0031 23.008V11.992A1.992 1.992 0 0028.994 10z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-295",
  fill: "#fcd669",
  d: "M17 10h7v15h-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 18v.5a2.5 2.5 0 002.5 2.5v-3zm2.5-3H23v3h-2.5z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M18 15h2.5v3H18zm2.5 6a2.5 2.5 0 002.5-2.5V18h-2.5z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.005 10A2 2 0 0041 11.992v11.016A1.996 1.996 0 0043.005 25H46V10z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46 10v5h16v-2.995A2 2 0 0060.006 10z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M46 15h16v5H46z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M46 20v5h14.006A1.997 1.997 0 0062 22.995V20z",
  fill: "#333"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M60.999 15H62v5h-1.001z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M93 12a2 2 0 00-2-2H74a2 2 0 00-2 2v3h21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.491 10A2.49 2.49 0 0072 12.5V15h21v-2.5a2.505 2.505 0 00-2.491-2.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#45b2e8",
  d: "M72 15h21v5H72z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M72 19v3a3 3 0 003 3h15a3 3 0 003-3v-3z",
  fill: "#f6f9fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.035 15a3.5 3.5 0 016.93 0z",
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.19 15l-8.418 9.16a1 1 0 01-1.504-.036L73.645 15 72 13.03V23a2 2 0 002 2h17a2 2 0 002-2v-9.97z",
  fill: "#e25950"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M104.995 10A1.997 1.997 0 00103 12.005V15h21v-2.995A2.006 2.006 0 00122.005 10z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#555abf",
  d: "M103 15h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M103 20v2.995A2.006 2.006 0 00104.995 25h17.01A1.997 1.997 0 00124 22.995V20z",
  fill: "#fcd669"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M135.995 10A1.997 1.997 0 00134 12.005V15h21v-2.995A2.006 2.006 0 00153.005 10z",
  fill: "#45b2e8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M134 15h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M134 15h1.001v5H134zm19.999 0H155v5h-1.001z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M134 20v2.995A2.006 2.006 0 00135.995 25h17.01A1.997 1.997 0 00155 22.995V20z",
  fill: "#45b2e8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144.5,
  cy: 17.5,
  r: 1.5,
  fill: "#f4b32e"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M166.995 10A1.997 1.997 0 00165 12.005V15h21v-2.995A2.006 2.006 0 00184.005 10z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M165 15h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M165 15h1.001v5H165zm19.999 0H186v5h-1.001z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M165 20v2.995A2.006 2.006 0 00166.995 25h17.01A1.997 1.997 0 00186 22.995V20z",
  fill: "#e25950"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M198 10h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2V12a2 2 0 012-2z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M196 15.664l3.498-2.4.001-.001h.002v.001l5.425 3.722h-1.767l-3.659-2.51-3.5 2.401zm9-5.569v1.213l-3.499 2.4-.001.001-.001-.001-4.758-3.264a1.983 1.983 0 011.121-.444l3.638 2.496z",
  fill: "#f6f9fc"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M204.909 17l-3.659-2.51-3.659 2.51H196v-.121l5.248-3.601.001-.001h.002v.001L205 15.85V17zm-5.158-3.278v.001h-.002v-.001l-3.601-2.47a1.99 1.99 0 01.601-.801l3.001 2.059 3.659-2.51H205v.121z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  fill: "#f6f9fc",
  d: "M205 14.625h-3.375V17h-2.25v-2.375H196v-2.25h3.375V10h2.25v2.375H205v2.25z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  fill: "#e25950",
  d: "M205 13.998h-4V17h-1v-3.002h-4v-.996h4V10h1v3.002h4v.996z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M213.24 16.5a.75.75 0 11.75-.75.75.75 0 01-.75.75zm-1.25 3a.5.5 0 11.5-.5.5.5 0 01-.5.5zm-1.25-5a.75.75 0 11.75-.75.75.75 0 01-.75.75zm-3 3a.75.75 0 11.75-.75.75.75 0 01-.75.75zm3 4a.75.75 0 11-.75.75.75.75 0 01.75-.75zm-10.75 1.023l-.684.653a.179.179 0 01-.3-.149l.068-.959-.922-.146a.186.186 0 01-.074-.334l.77-.544-.465-.834a.182.182 0 01.207-.268l.892.282.343-.895a.176.176 0 01.332 0l.343.895.892-.282a.182.182 0 01.207.268l-.465.834.77.544a.186.186 0 01-.074.334l-.922.146.068.959a.179.179 0 01-.3.149z",
  fill: "#f6f9fc"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fcd669",
  d: "M233 10h9v15h-9V10z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M229 10h5v15h-5a2 2 0 01-2-2V12a2 2 0 012-2z",
  fill: "#333"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M246 25h-5V10h5a2 2 0 012 2v11a2 2 0 01-2 2z",
  fill: "#e25950"
})));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M259.995 10A1.991 1.991 0 00258 11.998V18h21v-6.002A2.002 2.002 0 00277.005 10z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-295",
  d: "M258 18v4.994A2.006 2.006 0 00259.995 25h17.01A1.993 1.993 0 00279 22.994V18z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcd669",
  d: "M268.5 19.55l-2.645 1.591.705-2.946-2.34-2.186 2.957-.129L268.5 13l1.323 2.88 2.957.129-2.34 2.186.705 2.946-2.645-1.591z"
})));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M290.995 10A1.999 1.999 0 00289 11.998V16h21v-4.002A2.002 2.002 0 00308.005 10z",
  fill: "#f6f9fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M289.5 15.5h20v-3.502a1.502 1.502 0 00-1.495-1.498h-17.01a1.499 1.499 0 00-1.495 1.498z",
  fill: "none",
  stroke: "#eaeef3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#24b47e",
  d: "M289 15h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M289 20v2.995A2.006 2.006 0 00290.995 25h17.01A1.997 1.997 0 00310 22.995V20z",
  fill: "#e25950",
  "data-name": "Rectangle-34"
})));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M321.995 10A1.997 1.997 0 00320 12.005V15h21v-2.995A2.006 2.006 0 00339.005 10z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcd669",
  d: "M320 15h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M320 20v2.995A2.006 2.006 0 00321.995 25h17.01A1.997 1.997 0 00341 22.995V20z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#efc65e",
  d: "M320 15h1.001v5H320zm19.999 0H341v5h-1.001z"
})));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M353 10h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2V12a2 2 0 012-2z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  fill: "#fcd669",
  d: "M361.999 12l8.999 6.004-8.999 6.004L353 18.004 361.999 12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M358.051 16.993a3.477 3.477 0 00-.051.507 3.483 3.483 0 005.766 2.648 8.588 8.588 0 00-5.716-3.155zm6.523 2.147A3.461 3.461 0 00365 17.5a3.489 3.489 0 00-6.54-1.702 9.848 9.848 0 016.114 3.342z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M358.46 15.798a3.451 3.451 0 00-.408 1.195 8.588 8.588 0 015.714 3.155 3.49 3.49 0 00.808-1.008 9.848 9.848 0 00-6.114-3.342z",
  fill: "#fff"
})));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M387 10h11v15h-11V10z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M392.045 20.97l-.003-1.974-1.399-.008.177-.819-1.82-.277.647-1.197-.58-1.585 1.593.634.471-1.818.698.356.668-1.283.76 1.264.621-.286.299 1.757 1.773-.557-.545 1.47.595 1.235-1.76.287.161.811-1.442-.014.008 1.985zM388 25h-4a2 2 0 01-2-2V12a2 2 0 012-2h4zm13 0h-4V10h4a2 2 0 012 2v11a2 2 0 01-2 2z",
  fill: "#e25950"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  rx: 3,
  ry: 3,
  fill: "#fcd669",
  x: 413,
  y: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M414.992 10A1.99 1.99 0 00413 12v8l15-10z",
  fill: "#45b2e8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 416,
  cy: 13,
  r: 1,
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-87",
  d: "M434 23a1.997 1.997 0 01-1.992 2H419l15-10z",
  fill: "#45b2e8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M432 10h-1l-18 12v1a2 2 0 002 2h1l18-12v-1a2 2 0 00-2-2z",
  fill: "#e25950"
})));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M463 10h-3l-15.393 14.431A1.99 1.99 0 00446 25h3l15.393-14.431A1.99 1.99 0 00463 10z",
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  d: "M446 10a2 2 0 00-2 2v11a1.991 1.991 0 00.607 1.431L460 10z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M449 25h14a2 2 0 002-2V12a1.991 1.991 0 00-.607-1.431z",
  fill: "#e25950"
})));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M477 10h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2V12a2 2 0 012-2z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M490 19h-3v3h-3v-3h-3v-3h3v-3h3v3h3v3z"
})));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M514.499 18.5v-8h10.492a1.505 1.505 0 011.509 1.498V18.5z",
  fill: "#f7f7f7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.991 11a1.004 1.004 0 011.009.997V18h-11v-7h9.992m0-1h-10.993v9H527v-7.003A2.005 2.005 0 00524.991 10z",
  fill: "#e9ebf0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M506 18v4.994A2.006 2.006 0 00507.995 25h17.01A1.993 1.993 0 00527 22.994V18z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-295",
  d: "M507.997 10A1.993 1.993 0 00506 11.998V18h9v-8z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.34 13.422l-1.169.002a.162.162 0 01-.154-.112l-.362-1.112a.162.162 0 00-.31 0l-.36 1.111a.162.162 0 01-.155.113h-1.17a.162.162 0 00-.095.294l.946.687a.162.162 0 01.058.182l-.359 1.113a.162.162 0 00.25.182l.946-.634a.162.162 0 01.191 0l.946.634a.162.162 0 00.25-.182l-.361-1.111a.162.162 0 01.059-.183l.946-.687a.162.162 0 00.06-.182.165.165 0 00-.156-.114z",
  fill: "#fff"
})));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.006 35A2 2 0 0010 36.992v11.016A1.992 1.992 0 0012.006 50H17V35z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 35v15h4.994A2 2 0 0031 48.008V36.992A1.992 1.992 0 0028.994 35z",
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-295",
  fill: "#e25950",
  d: "M16 35h9v15h-9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.625 41.302l-2.014.005a.28.28 0 01-.267-.194l-.624-1.917a.28.28 0 00-.534 0l-.622 1.916a.28.28 0 01-.266.194h-2.015a.28.28 0 00-.165.507l1.63 1.185a.28.28 0 01.102.314l-.622 1.916a.28.28 0 00.432.314l1.63-1.093a.28.28 0 01.33 0l1.63 1.093a.28.28 0 00.432-.314l-.624-1.916a.28.28 0 01.102-.314l1.63-1.185a.28.28 0 00.103-.313.284.284 0 00-.268-.198z",
  fill: "#fcd669"
})));

var _ref20 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  rx: 2,
  ry: 2,
  fill: "#e25950",
  x: 41,
  y: 35
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.5 38a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-96",
  d: "M54.5 40a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.5 42a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-96",
  d: "M53.5 44a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcd669",
  d: "M47.471 43.588L45.013 45l.609-2.757-1.651-2.068 2.48-.138 1.02-2.137 1.021 2.137 2.479.138-1.651 2.068.689 2.757-2.538-1.412z"
})));

var _ref21 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M73.995 35A1.993 1.993 0 0072 37.006V42h21v-4.994A2.006 2.006 0 0091.005 35z",
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43458b",
  d: "M72 42h21v4H72z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M72 46v2a2.003 2.003 0 001.995 2h17.01A1.992 1.992 0 0093 48v-2z",
  fill: "#e25950"
})));

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M124 38h-21v-1a2 2 0 012-2h17a2 2 0 012 2z",
  fill: "#0172c6"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#f9f9f9",
  d: "M103.02 38h21v2h-21zm0 7h21v2h-21z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M103 47h21v1a2 2 0 01-2 2h-17a2 2 0 01-2-2z",
  fill: "#0172c6"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fill: "#e25950",
  d: "M103 40h21v5h-21z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M107.52 40a2.5 2.5 0 102.48 2.54 2.5 2.5 0 00-2.48-2.54zm0 4a1.5 1.5 0 111.48-1.46 1.5 1.5 0 01-1.48 1.46z",
  fill: "#f9f9f9"
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  cx: 107.52,
  cy: 42.54,
  r: 1.5,
  fill: "#0172c6"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M154 42v-5a1 1 0 00-1-1h-17a.981.981 0 00-.325.066L145 42zm-19.335 7.48a1.991 1.991 0 00.596.375 1.998 1.998 0 01-.595-.375z",
  fill: "#f6f9fc"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M153 35h-17a1.982 1.982 0 00-1.29.484.788.788 0 01.135.054l.83.528A.981.981 0 01136 36h17a1 1 0 011 1v5h1v-5a2 2 0 00-2-2z",
  fill: "#f6f9fc"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M135.995 50H136a1.988 1.988 0 01-.739-.145 1.966 1.966 0 00.734.145zM153 50h.005A1.991 1.991 0 00155 48.002V48a2 2 0 01-2 2z",
  fill: "#e25950"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M154 42h-9l-9.456 6.877-.735.535a.774.774 0 01-.143.067A1.982 1.982 0 00136 50h17a2 2 0 002-2v-6z",
  fill: "#e25950"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M134.04 48.403c-.008-.04-.006-.085-.012-.128.006.043.004.087.013.128zm.035.111a1.99 1.99 0 00.59.966 1.994 1.994 0 01-.59-.966zM134 48v.002a1.957 1.957 0 00.028.273A1.969 1.969 0 01134 48zm.075.514c-.01-.037-.026-.072-.034-.11.008.038.024.073.034.11z",
  fill: "#43458b"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M135.675 36.066l-.83-.528a.788.788 0 00-.136-.054A1.986 1.986 0 00134 37v11a1.969 1.969 0 00.028.275c.006.043.004.087.013.128.008.039.024.074.034.111a1.994 1.994 0 00.591.965.774.774 0 00.143-.067l.735-.535L145 42z",
  fill: "#43458b"
});

var _ref34 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e25950",
  d: "M165 39h21v7h-21v-7z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M165 48v-3h21v3a2 2 0 01-2 2h-17a2 2 0 01-2-2z",
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M186 37v3h-21v-3a2 2 0 012-2h17a2 2 0 012 2z",
  fill: "#333"
})));

var _ref35 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M196 42v6.002A2.002 2.002 0 00197.995 50h17.01A1.991 1.991 0 00217 48.002V42z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-295",
  d: "M196 37v6h21v-6a2 2 0 00-2-2h-17a2 2 0 00-2 2z",
  fill: "#45b2e8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M198.647 36.623c-.91-.62-1.647-.226-1.647.883v9.988c0 1.108.773 1.549 1.719.99L208 43z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M202.796 41.845l-1.458.004a.202.202 0 01-.193-.14l-.452-1.389a.202.202 0 00-.386 0l-.45 1.387a.202.202 0 01-.193.14h-1.46a.202.202 0 00-.118.367l1.18.858a.202.202 0 01.073.227l-.45 1.387a.202.202 0 00.313.228l1.18-.792a.202.202 0 01.238 0l1.18.792a.202.202 0 00.313-.227l-.453-1.387a.202.202 0 01.074-.227l1.18-.858a.202.202 0 00.075-.227.205.205 0 00-.194-.143z",
  fill: "#e25950"
})));

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M229 35h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2V37a2 2 0 012-2z",
  fill: "#e25950"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  fill: "#f6f9fc",
  d: "M248 44h-12v6h-3v-6h-6v-3h6v-6h3v6h12v3z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M264 35v15h13.008A1.993 1.993 0 00279 48.008V36.992A1.993 1.993 0 00277.008 35z",
  fill: "#f6f9fc"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-87",
  d: "M260 35a1.997 1.997 0 00-2 1.992v11.016A1.99 1.99 0 00260 50h8V35z",
  fill: "#24b47e"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M268 38.027v1.021a3.531 3.531 0 00-3 3.452 3.531 3.531 0 003 3.452v1.02a4.5 4.5 0 110-8.945z",
  fill: "#e25950"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Oval-38",
  d: "M271.482 40.403A3.63 3.63 0 00268.6 39a3.551 3.551 0 00-3.6 3.5 3.551 3.551 0 003.6 3.5 3.63 3.63 0 002.882-1.403 4.5 4.5 0 110-4.194z",
  fill: "#e25950"
});

var _ref42 = /*#__PURE__*/React.createElement("circle", {
  cx: 270.5,
  cy: 42.5,
  r: 1.5,
  fill: "#e25950"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M291 35h17a2 2 0 012 2v5h-21v-5a2 2 0 012-2z",
  fill: "#ffdd03"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  fill: "#555abf",
  d: "M289 42h21v4h-21z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M289 46h21v2a2 2 0 01-2 2h-17a2 2 0 01-2-2v-2z",
  fill: "#e25950"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M299.5 39a3.5 3.5 0 103.5 3.5 3.5 3.5 0 00-3.5-3.5zm0 6a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5z",
  fill: "#ffdd03"
});

var _ref47 = /*#__PURE__*/React.createElement("circle", {
  cx: 299.5,
  cy: 42.5,
  r: 2.5,
  fill: "#6fc242"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M321.995 35A1.997 1.997 0 00320 37.005V40h21v-2.995A2.006 2.006 0 00339.005 35z",
  fill: "#45b2e8"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M320 44v4.002A2.002 2.002 0 00321.995 50h17.01A1.999 1.999 0 00341 48.002V44z",
  fill: "#f6f9fc",
  "data-name": "Rectangle-34"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M320 40h21v5h-21z"
});

var _ref51 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M352.995 35A1.997 1.997 0 00351 37.005V40h21v-2.995A2.006 2.006 0 00370.005 35z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M351 40h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M351 45v2.995A2.006 2.006 0 00352.995 50h17.01A1.997 1.997 0 00372 47.995V45z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M358 41l3 1-3 2zm7 0v3l-3-2zm-4 2h1v1h-1z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "path-141",
  d: "M358 41l3 1-3 2zm7 0v3l-3-2zm-4 2h1v1h-1z",
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M351 40h1.001v5H351zm19.999 0H372v5h-1.001z"
})));

var _ref52 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcd669",
  d: "M382 38h21v9h-21v-9z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M382 39v-2a2 2 0 012-2h17a2 2 0 012 2v2zm19 11h-17a2 2 0 01-2-2v-2h21v2a2 2 0 01-2 2z",
  fill: "#e25950"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  fill: "#f6f9fc",
  d: "M387 40h2v2.5h-2V40z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M387 45v-2.5h2v.5a2 2 0 01-2 2zm-2-5h2v2.5h-2z",
  fill: "#e25950"
});

var _ref56 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M415 35h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2V37a2 2 0 012-2z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M427.906 43.219a.844.844 0 11.844-.844.843.843 0 01-.844.844zm-1.895-3.444a.849.849 0 111.19-.01.849.849 0 01-1.19.01zm1.165 5.2A.85.85 0 11426 45a.85.85 0 011.176-.025zm-3.801 2.775a.844.844 0 11.844-.844.844.844 0 01-.844.844zm0-9.063a.844.844 0 11.843-.844.843.843 0 01-.843.844zm-3.765 7.489a.849.849 0 111.19-.01.849.849 0 01-1.19.01zm-.036-6.401a.85.85 0 011.201-1.201.85.85 0 01-1.201 1.201zm.113 2.6a.844.844 0 11-.844-.843.843.843 0 01.844.843z",
  fill: "#fce883"
})));

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M446 35h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2V37a2 2 0 012-2z",
  fill: "#f6f9fc"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  fill: "#555abf",
  d: "M465 44h-12v6h-3v-6h-6v-3h6v-6h3v6h12v3z"
});

var _ref59 = /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  rx: 2,
  fill: "#f6f9fc",
  x: 475,
  y: 35
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M494 36a1 1 0 011 1v11a1 1 0 01-1 1h-17a1 1 0 01-1-1V37a1 1 0 011-1h17m0-1h-17a2 2 0 00-2 2v11a2 2 0 002 2h17a2 2 0 002-2V37a2 2 0 00-2-2z",
  fill: "#eaeef3"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  fill: "#0172c6",
  d: "M496 41h-13.42v-6h-3v6H475v3h4.58v6h3v-6H496v-3z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  fill: "#e25950",
  d: "M496 42h-14.42v-7h-1v7H475v1h5.58v7h1v-7H496v-1z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M512 35h9v15h-9V35z"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M508 35h5v15h-5a2 2 0 01-2-2V37a2 2 0 012-2z",
  fill: "#555abf"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M525 50h-5V35h5a2 2 0 012 2v11a2 2 0 01-2 2z",
  fill: "#e25950"
});

var _ref66 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.995 60A1.997 1.997 0 0010 62.005V65h21v-2.995A2.006 2.006 0 0029.005 60z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcd669",
  d: "M10 65h21v5H10z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M10 70v2.995A2.006 2.006 0 0011.995 75h17.01A1.997 1.997 0 0031 72.995V70z",
  fill: "#217ab7"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e9c863",
  d: "M10 65h1.001v5H10zm20 0h1.001v5H30z"
})));

var _ref67 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M61.929 73.5H59.5V75h-16v-1.5h-2.429A1.966 1.966 0 0141 73V62a1.966 1.966 0 01.071-.5H43.5V60h16v1.5h2.429A1.966 1.966 0 0162 62v11a1.966 1.966 0 01-.071.5z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M58.659 60H60a2 2 0 012 2v.454L58.629 65H62v5h-3.288L62 72.483V73a2 2 0 01-2 2h-1.258L54 71.419V75h-5v-3.581L44.258 75H43a2 2 0 01-2-2v-.517L44.288 70H41v-5h3.371L41 62.454V62a2 2 0 012-2h1.341L49 63.519V60h5v3.519z",
  fill: "#f6f9fc"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M53 69v6h-3v-6h-9v-3h9v-6h3v6h9v3zm.5-3.5v-.218l6.929-5.233a1.99 1.99 0 011.138.722L55.306 65.5zm-12.291-4.374a2.005 2.005 0 01.896-.906l6.99 5.28h-2.094zM49.5 69.5v.218l-6.929 5.233a1.99 1.99 0 01-1.138-.722l6.261-4.729zm12.291 4.374a2 2 0 01-.896.906l-6.99-5.28h2.094z",
  fill: "#e25950"
})));

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M74 60h17a2 2 0 012 2v5.5H72V62a2 2 0 012-2z",
  fill: "#f6f9fc"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M91 61a1 1 0 011 1v5.5h1V62a2 2 0 00-2-2H74a2 2 0 00-2 2v5.5h1V62a1 1 0 011-1h17",
  fill: "#eaeef3"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M76.5 67.5a4 4 0 018 0zm4 0H72V73a2 2 0 002 2h17a2 2 0 002-2v-5.5h-4.5",
  fill: "#e25950"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M84.5 67.5a4 4 0 01-8 0z",
  fill: "#fff"
});

var _ref72 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M103 64h21v7h-21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.995 60A1.992 1.992 0 00103 62v2h21v-2a2.003 2.003 0 00-1.995-2z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43458b",
  d: "M103 65h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M103 71v2a2.003 2.003 0 001.995 2h17.01A1.992 1.992 0 00124 73v-2z",
  fill: "#24b47e"
})));

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M153 60h-17a2 2 0 00-2 2v11a2 2 0 002 2h17a2 2 0 002-2V62a2 2 0 00-2-2z",
  fill: "#555abf"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M134 64h10v2h-10z"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M140 60v10h-2V60zm4 2h11v2h-11z"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M154 62h1v2h-1z"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M144 66h11v2h-11z"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M154 66h1v2h-1z"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M134 70h21v2h-21z"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M154 70h1v2h-1z"
});

var _ref81 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M167.006 60A2 2 0 00165 61.992v11.016A1.992 1.992 0 00167.006 75H172V60zM179 60v15h4.994A2 2 0 00186 73.008V61.992A1.992 1.992 0 00183.994 60z",
  fill: "#45b2e8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M172 60h7v15h-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.5 69a1.5 1.5 0 111.5-1.5 1.502 1.502 0 01-1.5 1.5zm0-2a.5.5 0 10.5.5.5.5 0 00-.5-.5z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M172 75v-1.001h7v1zm0-14v-1h7v1z"
})));

var _ref82 = /*#__PURE__*/React.createElement("rect", {
  x: 197,
  y: 61,
  width: 19,
  height: 13,
  rx: 1.77,
  fill: "#0172c6"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M214.23 61a1.77 1.77 0 011.77 1.77v9.46a1.77 1.77 0 01-1.77 1.77h-15.46a1.77 1.77 0 01-1.77-1.77v-9.46a1.77 1.77 0 011.77-1.77h15.46m0-1h-15.46a2.77 2.77 0 00-2.77 2.77v9.46a2.77 2.77 0 002.77 2.77h15.46a2.77 2.77 0 002.77-2.77v-9.46a2.77 2.77 0 00-2.77-2.77z",
  fill: "#e25950"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcd669",
  d: "M207 71h-1l-2-2h5l-2 2z"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  fill: "#9cdbff",
  d: "M207 64h-1l-2.17 2.35L204 68h5l.21-1.58L207 64z"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M204.5 69h1l-1-2v2z"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M207 67a4.38 4.38 0 011 3",
  fill: "none",
  stroke: "#0a9362",
  strokeMiterlimit: 10
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M206.5 64.19c1 .67 2.5 2 2.5 3.31s-1.52 2.63-2.5 3.31c-1-.67-2.5-2-2.5-3.31s1.52-2.63 2.5-3.31m0-1.19s-3.5 2-3.5 4.5 3.5 4.5 3.5 4.5 3.5-2 3.5-4.5-3.5-4.5-3.5-4.5z",
  fill: "#e25950"
});

var _ref89 = /*#__PURE__*/React.createElement("circle", {
  cx: 207,
  cy: 67,
  r: 1,
  fill: "#0a9362"
});

var _ref90 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M229 60h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2V62a2 2 0 012-2z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M237.31 67.4a2.311 2.311 0 011.77-1.903c1.389-.542 2.732.89 2.91 1.681-.054.046-.147-.023-.27-.093a.492.492 0 00-.56-.032c-.384.259-.466.476-.916.632a1.226 1.226 0 01-1.247-.329 1.22 1.22 0 00-1.686.044m-.271.441a2.31 2.31 0 01-2.55.5c-1.441-.379-1.686-2.326-1.365-3.071.159-.013.136.573.598.589a2.813 2.813 0 00.41-.018 1.552 1.552 0 01.702.046 1.224 1.224 0 01.816.998 1.22 1.22 0 001.389.956m.36.091a2.311 2.311 0 01-.357 2.574c-.827 1.239-2.748.837-3.347.291.039-.156.585.057.75-.374s.11-.657.39-1.043a1.225 1.225 0 011.209-.446 1.22 1.22 0 001.355-1.002m.114-.311a2.311 2.311 0 012.357 1.094c.943 1.153-.003 2.873-.7 3.287-.138-.083.226-.543-.14-.828s-.595-.296-.882-.677a1.224 1.224 0 01-.073-1.287 1.22 1.22 0 00-.562-1.589m-.541-.119a2.308 2.308 0 01-1.223-2.292c-.06-1.489 1.731-2.293 2.537-2.203.06.149-.508.297-.388.744s.298.596.298 1.072a1.225 1.225 0 01-.716 1.072 1.218 1.218 0 00-.507 1.607",
  fill: "#fff"
})));

var _ref91 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M259.995 60A1.997 1.997 0 00258 62.005V65h21v-2.995A2.006 2.006 0 00277.005 60z",
  fill: "#45b2e8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M258 65h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M258 70v2.995A2.006 2.006 0 00259.995 75h17.01A1.997 1.997 0 00279 72.995V70z",
  fill: "#45b2e8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M258 65h1.001v5H258zm19.999 0H279v5h-1.001z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M268 67.5a.5.5 0 11.5.5.5.5 0 01-.5-.5zm-3-1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm0 2a.5.5 0 11.5.5.5.5 0 01-.5-.5zm6 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm0-2a.5.5 0 11.5.5.5.5 0 01-.5-.5z",
  fill: "#45b2e8"
})));

var _ref92 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M290.995 60A1.991 1.991 0 00289 61.998V68h21v-6.002A2.002 2.002 0 00308.005 60z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-295",
  d: "M289 68v4.994A2.006 2.006 0 00290.995 75h17.01A1.993 1.993 0 00310 72.994V68z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M295 65h9v5h-9z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-927",
  d: "M303.902 70h-8.804c.454-1.141 2.408-2 4.401-2s3.947.859 4.402 2zm-5.402-4h2v1l-.983 1-1.017-1z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M297 67h1v1h-1zm4 0h1v1h-1z",
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-930",
  d: "M296 66h1v1h-1zm6 0h1v1h-1z",
  fill: "#fcd669"
})));

var _ref93 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M321.995 60A1.997 1.997 0 00320 62.005V65h21v-2.995A2.006 2.006 0 00339.005 60z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M320 65h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M320 70v2.995A2.006 2.006 0 00321.995 75h17.01A1.997 1.997 0 00341 72.995V70z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M320 65h1.001v5H320zm19.999 0H341v5h-1.001z"
})));

var _ref94 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M351 67v6.002A2.002 2.002 0 00352.995 75h17.01A1.991 1.991 0 00372 73.002V67z",
  fill: "#f6f9fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M351.5 67.5v5.502a1.502 1.502 0 001.495 1.498h17.01a1.491 1.491 0 001.495-1.498V67.5z",
  fill: "none",
  stroke: "#eaeef3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M352.995 60A1.991 1.991 0 00351 61.998V68h21v-6.002A2.002 2.002 0 00370.005 60z",
  fill: "#e25950"
})));

var _ref95 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M388 60h9v15h-9V60z"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M384 60h5v15h-5a2 2 0 01-2-2V62a2 2 0 012-2z",
  fill: "#24b47e"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M401 75h-5V60h5a2 2 0 012 2v11a2 2 0 01-2 2z",
  fill: "#f79a59"
});

var _ref98 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M414.493 60A1.493 1.493 0 00413 61.5V63h21v-1.5a1.5 1.5 0 00-1.493-1.5z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M414.001 63h18.998v9h-18.998z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M425.125 67.5L424 66h-1l-1.125 1.5L423 69h1zm.75 0L427 69h-2l-1.5 2.5L422 69h-2l1.125-1.5L420 66h2l1.5-2.5L425 66h2z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M413 72v1.5a1.5 1.5 0 001.493 1.5h18.014A1.493 1.493 0 00434 73.5V72z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M413 63h1.001v9H413zm19.999 0H434v9h-1.001z"
})));

var _ref99 = /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  rx: 2,
  fill: "#e25950",
  x: 444,
  y: 60
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  fillRule: "evenodd",
  d: "M453.57 72.98l1.19-1.62-1.97-2.48 2.85-1.57 2.7.63.5-.87.64-3.09.83-.1.25-.44-1.95.04-.63 3.09-2.5-.87-.97-3.01h-1l-3 1-.5-.67h-.5l1 1.68 3-1.01.5 2.51-2.5 2.08.38 1.02 1.66 1.99.27.41-.46.7.21.58z"
});

var _ref101 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M476.995 60A1.997 1.997 0 00475 62.005V65h21v-2.995A2.006 2.006 0 00494.005 60z",
  fill: "#f79a59"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M475 65h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475 70v2.995A2.006 2.006 0 00476.995 75h17.01A1.997 1.997 0 00496 72.995V70z",
  fill: "#24b47e",
  "data-name": "Rectangle-34"
}), /*#__PURE__*/React.createElement("path", {
  d: "M485.5 69a1.5 1.5 0 111.5-1.5 1.502 1.502 0 01-1.5 1.5zm0-2a.5.5 0 10.5.5.5.5 0 00-.5-.5z",
  fill: "#6772e5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M475 65h1.001v5H475zm19.999 0H496v5h-1.001z"
})));

var _ref102 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M507.995 60A1.997 1.997 0 00506 62.005V65h21v-2.995A2.006 2.006 0 00525.005 60z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M506 65h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M506 70v2.995A2.006 2.006 0 00507.995 75h17.01A1.997 1.997 0 00527 72.995V70z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M514 66h1v3h-1zm2 0h1v3h-1zm2 0h1v3h-1z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M506 65h1.001v5H506zm19.999 0H527v5h-1.001z"
})));

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M11.995 85A1.997 1.997 0 0010 87.005V90h21v-2.995A2.006 2.006 0 0029.005 85z",
  fill: "#24b47e"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10 90h21v5H10z"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M10 95v2.995A2.006 2.006 0 0011.995 100h17.01A1.997 1.997 0 0031 97.995V95z",
  fill: "#e25950"
});

var _ref106 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.5,
  cy: 92.5,
  r: 1,
  fill: "none",
  stroke: "#e25950"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M10 90h1.001v5H10zm19.999 0H31v5h-1.001z"
});

var _ref108 = /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  rx: 2,
  fill: "#0172c6",
  x: 41,
  y: 85
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M62 91H48.58v-6h-3v6H41v3h4.58v6h3v-6H62v-3z"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  fill: "#e25950",
  d: "M62 92H47.58v-7h-1v7H41v1h5.58v7h1v-7H62v-1z"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M78 85h9v15h-9V85z"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M74 85h5v15h-5a2 2 0 01-2-2V87a2 2 0 012-2z",
  fill: "#24b47e"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M91 100h-5V85h5a2 2 0 012 2v11a2 2 0 01-2 2z",
  fill: "#e25950"
});

var _ref114 = /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  rx: 2,
  fill: "#f6f9fc",
  x: 103,
  y: 85
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M115 87.5c0 .83-1.5 2.5-1.5 2.5s-1.5-1.67-1.5-2.5a1.5 1.5 0 013 0z",
  fill: "#e25950"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M122 86a1 1 0 011 1v11a1 1 0 01-1 1h-17a1 1 0 01-1-1V87a1 1 0 011-1h17m0-1h-17a2 2 0 00-2 2v11a2 2 0 002 2h17a2 2 0 002-2V87a2 2 0 00-2-2z",
  fill: "#eaeef3"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M115.17 92.11l8.52-6.17A2 2 0 00122 85h-.42l-8.14 5.89L105 85a2 2 0 00-1.81 1.16l8.53 6-8.72 6.25a2 2 0 001.4 1.49l9-6.55 9.3 6.5a2 2 0 001.3-1.59z",
  fill: "#e25950"
});

var _ref118 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M154.223 85.428a1.058 1.058 0 01-.091.068L144.5 91l-9.632-5.504a1.023 1.023 0 01-.091-.068A1.989 1.989 0 00134 87v1l8 4.5-8 4.5v1a1.989 1.989 0 00.777 1.572 1.023 1.023 0 01.091-.068L144.5 94l9.632 5.504a1.058 1.058 0 01.091.068A1.989 1.989 0 00155 98v-1l-8-4.5 8-4.5v-1a1.989 1.989 0 00-.777-1.572z",
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.5 91l9.632-5.504a1.058 1.058 0 00.091-.068A1.98 1.98 0 00153 85h-17a1.98 1.98 0 00-1.223.428 1.023 1.023 0 00.091.068zm0 3l-9.632 5.504a1.023 1.023 0 00-.091.068A1.98 1.98 0 00136 100h17a1.98 1.98 0 001.223-.428 1.058 1.058 0 00-.091-.068z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134 88v9l8-4.5-8-4.5zm21 9v-9l-8 4.5 8 4.5z"
})));

var _ref119 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M165 90h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186 87.005A2.006 2.006 0 00184.005 85h-17.01a1.975 1.975 0 00-1.325.513.78.78 0 01.135.063L172 90h14z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.675 99.485a1.975 1.975 0 001.32.515h17.01A1.997 1.997 0 00186 97.995V95h-14l-6.194 4.424a.772.772 0 01-.131.06z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172 90l-6.194-4.424a.78.78 0 00-.135-.063 1.995 1.995 0 00-.671 1.493v10.99a1.996 1.996 0 00.675 1.49.772.772 0 00.131-.06L172 95l3.5-2.5z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168.5,
  cy: 92.5,
  r: 1.5,
  fill: "#f6f9fc"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M185 89.999h1v5h-1z"
})));

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M198 85h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2V87a2 2 0 012-2z",
  fill: "#f6f9fc"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M206.5 89a3.5 3.5 0 11-3.5 3.5 3.5 3.5 0 013.5-3.5z",
  fill: "#e25950"
});

var _ref122 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  rx: 2,
  ry: 2,
  fill: "#e25950",
  x: 227,
  y: 85
}), /*#__PURE__*/React.createElement("path", {
  d: "M240.5 96a.5.5 0 11.5-.5.5.5 0 01-.5.5zm-6-6a.5.5 0 11.5-.5.5.5 0 01-.5.5zm6 0a.5.5 0 11.5-.5.5.5 0 01-.5.5zm-6 6a.5.5 0 11.5-.5.5.5 0 01-.5.5zm3-7a.5.5 0 11.5-.5.5.5 0 01-.5.5zm-4 4a.5.5 0 11.5-.5.5.5 0 01-.5.5zm4 4a.5.5 0 11.5-.5.5.5 0 01-.5.5zm4-4a.5.5 0 11.5-.5.5.5 0 01-.5.5zm-4 2a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5z",
  fill: "#fedc32"
})));

var _ref123 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  rx: 3,
  ry: 3,
  fill: "#fcd669",
  x: 258,
  y: 85
}), /*#__PURE__*/React.createElement("rect", {
  x: 258.5,
  y: 85.5,
  width: 20,
  height: 14,
  rx: 3,
  ry: 3,
  fill: "none",
  stroke: "#000",
  strokeOpacity: 0.08
}), /*#__PURE__*/React.createElement("path", {
  d: "M279 88l-18 12h-2.001a.998.998 0 01-.999-1.008V97l18-12h2.001a.998.998 0 01.999 1.008z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-87",
  d: "M259.992 85A1.99 1.99 0 00258 87v8l15-10z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-87",
  d: "M279 98a1.997 1.997 0 01-1.992 2H264l15-10z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 265.5,
  cy: 94.5,
  r: 1.5,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 271.5,
  cy: 90.5,
  r: 1.5,
  fill: "#fff"
})));

var _ref124 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M289 88h21v9h-21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M290.493 85A1.493 1.493 0 00289 86.5V88h21v-1.5a1.5 1.5 0 00-1.493-1.5z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e25950",
  d: "M289 89h21v7h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M289 97v1.5a1.5 1.5 0 001.493 1.5h18.014A1.493 1.493 0 00310 98.5V97z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M294.5 94a1.5 1.5 0 10-1.5-1.5 1.5 1.5 0 001.5 1.5z",
  fill: "#fff"
})));

var _ref125 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M322 85h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2V87a2 2 0 012-2z",
  fill: "#f6f9fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M321.995 85h17.01A2 2 0 01341 86.992v11.016a1.994 1.994 0 01-1.995 1.992h-17.01A2 2 0 01320 98.008V86.992A1.994 1.994 0 01321.995 85zm0 1a.997.997 0 00-.995.998v11.004a1 1 0 00.995.998h17.01a.997.997 0 00.995-.998V86.998a1 1 0 00-.995-.998z",
  fill: "#dfe5eb"
}), /*#__PURE__*/React.createElement("path", {
  d: "M327 92.5a3.5 3.5 0 116.663 1.5h-6.326a3.486 3.486 0 01-.337-1.5z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334 88.207V88h1.207l1.293 1.793V90h-1.207zm-9.5 1.586L325.793 88H327v.207L325.707 90H324.5zm9.5 7L335.293 95h1.207v.207L335.207 97H334zm-9.5-1.586V95h1.207L327 96.793V97h-1.207z",
  fillOpacity: 0.9
}), /*#__PURE__*/React.createElement("path", {
  d: "M332.175 91.736a1.733 1.733 0 011.773 1.37 3.501 3.501 0 01-3.378 2.893 3.668 3.668 0 01-3.163-1.86A3.485 3.485 0 01327 92.53a3.28 3.28 0 01.392-1.53c.002.047.004.098.004.154 0 .674-.003 2.084 1.692 2.084s1.646-1.502 3.087-1.502z",
  fill: "#43458b"
})));

var _ref126 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M353 85v5h19v-2.995A1.999 1.999 0 00370.003 85z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M352 90h20v5h-20z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M353 95v5h17.003A1.999 1.999 0 00372 97.995V95z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M359 90v5l-5.995 5A1.996 1.996 0 01351 98.008V86.992A2 2 0 01353.005 85z",
  "data-name": "Rectangle-295"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M370.999 90H372v5h-1.001z"
})));

var _ref127 = /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  rx: 2,
  ry: 2,
  fill: "#1cafc8",
  x: 382,
  y: 85
});

var _ref128 = /*#__PURE__*/React.createElement("circle", {
  cx: 392.5,
  cy: 92.5,
  r: 3.5,
  fill: "#fcd669"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M384 89h2v1h-2zm0 2h2v1h-2zm0 2h2v1h-2zm0 2h2v1h-2z",
  fill: "#fcd669"
});

var _ref130 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M414.995 85A1.992 1.992 0 00413 87v2h21v-2a2.003 2.003 0 00-1.995-2z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43458b",
  d: "M413 89h21v7h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M413 96v2a2.003 2.003 0 001.995 2h17.01A1.992 1.992 0 00434 98v-2z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 423.5,
  cy: 92.5,
  r: 1.5,
  fill: "#fff"
})));

var _ref131 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M445.995 85A1.992 1.992 0 00444 87v2h21v-2a2.003 2.003 0 00-1.995-2z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M444 89h21v7h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M444 96v2a2.003 2.003 0 001.995 2h17.01A1.992 1.992 0 00465 98v-2z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M455 94v1h-1v-1h-2l2.5-4 2.5 4z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M444 89h1.001v7H444zm19.999 0H465v7h-1.001z"
})));

var _ref132 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  rx: 2,
  ry: 2,
  fill: "#45b2e8",
  x: 475,
  y: 85
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M485.5 87L480 98h11l-5.5-11z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M485.5 90l-4 8h8l-4-8z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-1065",
  fill: "#fcd669",
  d: "M485.5 93.8L480 98h11l-5.5-4.2z"
})));

var _ref133 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M507.995 85A1.997 1.997 0 00506 87.005V90h21v-2.995A2.006 2.006 0 00525.005 85z",
  fill: "#555abf"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M506 90h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M506 95v2.995a2.006 2.006 0 001.995 2.005h17.01A1.997 1.997 0 00527 97.995V95z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M516.5 91l-1.856 2.227c-.356.427-.2.773.356.773h3c.552 0 .713-.344.356-.773z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M506 90h1.001v5H506zm19.999 0H527v5h-1.001z"
})));

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M12 110a2 2 0 00-2 2v3h21v-3a2 2 0 00-2-2z",
  fill: "#fcd669"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  fill: "#24b47e",
  d: "M10 115h21v5H10z"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M10 120v3a2 2 0 002 2h17a2 2 0 002-2v-3z",
  fill: "#e25950"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M41 114h21v7H41v-7z"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M41 123v-3h21v3a2 2 0 01-2 2H43a2 2 0 01-2-2z",
  fill: "#45b2e8"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M62 112v3H41v-3a2 2 0 012-2h17a2 2 0 012 2z",
  fill: "#e25950"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M73.995 110A1.992 1.992 0 0072 112v4h21v-4a2 2 0 00-1.995-2z",
  fill: "#b1372f"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  fill: "#f8fafc",
  d: "M72 116h21v3H72z"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "M72 119v4a2 2 0 001.995 2h17.01A1.992 1.992 0 0093 123v-4z",
  fill: "#b1372f"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M72 116h1.001v3H72zm19.999 0H93v3h-1.001z"
});

var _ref144 = /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  rx: 2,
  fill: "#e25950",
  x: 103,
  y: 110
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#24b47e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M113.5 112.5l3 9-8-6h10l-8 6 3-9z"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  d: "M136.006 110a2 2 0 00-2.006 1.992v11.016a1.992 1.992 0 002.006 1.992H141v-15z",
  fill: "#f6f9fc"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-87",
  d: "M153.14 110a2.1 2.1 0 011.86 2.276V118h-14v-8z",
  fill: "#e25950"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-87",
  d: "M155 123.257a1.805 1.805 0 01-1.86 1.743H141v-7h14z",
  fill: "#24b47e"
});

var _ref149 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  rx: 2,
  ry: 2,
  fill: "#fcd669",
  x: 165,
  y: 110
}), /*#__PURE__*/React.createElement("path", {
  d: "M185 116.143l1-.143v-3.757l-1 .382-6.497 2.477-.47-.883L182.61 111l1.418-.997c-.011 0-.019-.003-.028-.003h-7l-.25 1-.75 3h-1l-.75-3-.25-1h-6.962l1.422 1 4.576 3.22-.47.882-6.566-2.504-.967-.368-.03-.259c0 .01-.003.019-.003.029v4l1 .143 6 .857v1l-6 .857-1 .143v4c0 .03.008.059.009.09l.024-.236.967-.37 6.566-2.503.47.883-4.457 3.136-1.422 1H174l.25-1 .75-3h1l.75 3 .25 1h6.913l-1.421-1-4.459-3.136.47-.883 6.497 2.477 1 .382V119l-1-.143-6-.857v-1zM175.5 120a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5z",
  fill: "#e25950"
})));

var _ref150 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M198.006 110a2 2 0 00-2.006 1.992v11.016a1.992 1.992 0 002.006 1.992H203v-15z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210 110v15h4.994a2 2 0 002.006-1.992v-11.016a1.992 1.992 0 00-2.006-1.992z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-295",
  fill: "#fcd669",
  d: "M203 110h7v15h-7z"
})));

var _ref151 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M228.995 110a1.997 1.997 0 00-1.995 2.005V115h21v-2.995a2.006 2.006 0 00-1.995-2.005z",
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#24b47e",
  d: "M227 115h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M227 120v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V120z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M241.633 116l-2.625.006a.364.364 0 01-.347-.253l-.813-2.497a.364.364 0 00-.695 0l-.811 2.496a.364.364 0 01-.347.253h-2.626a.364.364 0 00-.215.661l2.124 1.544a.364.364 0 01.132.409l-.81 2.497a.364.364 0 00.562.41l2.124-1.426a.364.364 0 01.43 0l2.125 1.425a.364.364 0 00.563-.409l-.813-2.497a.364.364 0 01.132-.41l2.125-1.543a.364.364 0 00.134-.409.37.37 0 00-.35-.257z",
  fill: "#fff"
})));

var _ref152 = /*#__PURE__*/React.createElement("path", {
  d: "M268 110v15h9.008a1.993 1.993 0 001.992-1.992v-11.016a1.997 1.997 0 00-1.992-1.992z",
  fill: "#e25950"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  d: "M264 114h2v2h-2v2h-2v-2h-2v-2h2v-2h2z",
  fill: "#9c9b9a",
  fillOpacity: 0.5
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M295 110h9v15h-9v-15z"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M291 110h5v15h-5a2 2 0 01-2-2v-11a2 2 0 012-2z",
  fill: "#24b47e"
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M308 125h-5v-15h5a2 2 0 012 2v11a2 2 0 01-2 2z",
  fill: "#e25950"
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M297.575 118a1.913 1.913 0 003.827 0h.852l.002.014a2.753 2.753 0 11-5.505 0l.002-.014z",
  fill: "#24b47e"
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M299.5 116a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5z",
  fill: "#b5562b"
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  d: "M339 125h-17a2 2 0 01-2-2v-7h8v-6h11a2 2 0 012 2v11a2 2 0 01-2 2z",
  fill: "#e25950"
});

var _ref160 = /*#__PURE__*/React.createElement("path", {
  d: "M320 121h21v1h-21zm0-2h21v1h-21zm0-2h21v1h-21zm8-2h13v1h-13zm0-2h13v1h-13zm0-2h12.72a2 2 0 01.28 1h-13zm12.72 13h-20.44a2 2 0 01-.28-1h21a2 2 0 01-.28 1z",
  fill: "#f6f9fc"
});

var _ref161 = /*#__PURE__*/React.createElement("path", {
  d: "M330 110h-8a2 2 0 00-2 2v8h10z",
  fill: "#555abf"
});

var _ref162 = /*#__PURE__*/React.createElement("path", {
  d: "M326.5 117.75a2.75 2.75 0 111.84-4.75 3.5 3.5 0 10-2.84 5.5 3.46 3.46 0 002.84-1.5 2.73 2.73 0 01-1.84.75z",
  fill: "#fcd669"
});

var _ref163 = /*#__PURE__*/React.createElement("circle", {
  cx: 327.5,
  cy: 115,
  r: 1,
  fill: "#fcd669"
});

var _ref164 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M354 125h3l15-10v-2l-18 12zm12-15l-15 10v2l18-12h-3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M369 110l-18 12a3 3 0 003 3l18-12a3 3 0 00-3-3z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M354 110a3 3 0 00-3 3v7l15-10zm-1 4v-2h2v2z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M369 125a3 3 0 003-3v-7l-15 10z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcd669",
  d: "M353 112h2v2h-2z"
})));

var _ref165 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M383.995 110a1.997 1.997 0 00-1.995 2.005V115h21v-2.995a2.006 2.006 0 00-1.995-2.005z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M382 115h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M382 120v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V120z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 392.5,
  cy: 117.5,
  r: 1.5,
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M382 115h1.001v5H382zm19.999 0H403v5h-1.001z"
})));

var _ref166 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M415.006 110a2 2 0 00-2.006 1.992v11.016a1.992 1.992 0 002.006 1.992H420v-15zM427 110v15h4.994a2 2 0 002.006-1.992v-11.016a1.992 1.992 0 00-2.006-1.992z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M420 110h7v15h-7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M420 125v-1.001h7v1zm0-14v-1h7v1z"
})));

var _ref167 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M445.995 110a1.997 1.997 0 00-1.995 2.005V115h21v-2.995a2.006 2.006 0 00-1.995-2.005z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M444 115h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M444 120v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V120z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M454.5 119a1.5 1.5 0 111.5-1.5 1.502 1.502 0 01-1.5 1.5zm0-2a.5.5 0 10.5.5.5.5 0 00-.5-.5z",
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M444 115h1.001v5H444zm19.999 0H465v5h-1.001z"
})));

var _ref168 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M475 114h21v7h-21v-7z"
});

var _ref169 = /*#__PURE__*/React.createElement("path", {
  d: "M496 112v3h-21v-3a2 2 0 012-2h17a2 2 0 012 2z",
  fill: "#e25950"
});

var _ref170 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M475 123v-3h21v3a2 2 0 01-2 2h-17a2 2 0 01-2-2z",
  fill: "#6772e5"
});

var _ref171 = /*#__PURE__*/React.createElement("path", {
  d: "M508 110h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2v-11a2 2 0 012-2z",
  fill: "#e25950"
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  fill: "#f6f9fc",
  d: "M527 119h-12v6h-3v-6h-6v-3h6v-6h3v6h12v3z"
});

var _ref173 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  fill: "#555abf",
  d: "M527 118h-13v7h-1v-7h-7v-1h7v-7h1v7h13v1z"
});

var _ref174 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 135h17a2 2 0 012 2v11a2 2 0 01-2 2H12a2 2 0 01-2-2v-11a2 2 0 012-2z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M10 140.664l3.498-2.4.001-.001h.001l.001.001 5.425 3.722h-1.767l-3.659-2.51-3.5 2.401zm9-5.569v1.213l-3.499 2.4-.001.001-.001-.001-4.758-3.264a1.983 1.983 0 011.121-.444l3.638 2.496z",
  fill: "#f6f9fc"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M18.909 142l-3.659-2.51-3.659 2.51H10v-.121l5.249-3.601v-.001h.002v.001L19 140.85V142zm-5.158-3.278v.001h-.002v-.001l-3.601-2.47a1.99 1.99 0 01.601-.801l3.001 2.059 3.659-2.51H19v.121z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  fill: "#f6f9fc",
  d: "M19 139.625h-3.375V142h-2.25v-2.375H10v-2.25h3.375V135h2.25v2.375H19v2.25z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  fill: "#e25950",
  d: "M19 138.998h-4V142h-1v-3.002h-4v-.996h4V135h1v3.002h4v.996z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M26.22 141.44a1.22 1.22 0 111.186-1.22 1.22 1.22 0 01-1.185 1.22zm-2-2a1.22 1.22 0 111.186-1.22 1.22 1.22 0 01-1.186 1.22zm-.78 1.781a1.22 1.22 0 11-1.22-1.186 1.22 1.22 0 011.22 1.186zm.78 3.781a1.22 1.22 0 11-1.185 1.22 1.22 1.22 0 011.185-1.22z",
  fill: "#f6f9fc"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M26.188 140.874a.687.687 0 11.686-.688.687.687 0 01-.686.688zm-2 6.001a.688.688 0 11.687-.688.688.688 0 01-.688.688zm0-8.001a.687.687 0 11.685-.688.687.687 0 01-.685.688zm-2 3a.688.688 0 11.617-.336.688.688 0 01-.617.336z",
  fill: "#e25950"
})));

var _ref175 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M45 135v6h17v-4.002A1.996 1.996 0 0060 135z",
  fill: "#f6f9fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.5 142.5v-5.502a1.502 1.502 0 00-1.495-1.498h-17.01",
  fill: "none",
  stroke: "#eaeef3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46 140v-5h-2.995A2 2 0 0041 136.992v11.016A1.996 1.996 0 0043.005 150H46v-5h16v-5z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46 145v5h14.006A1.997 1.997 0 0062 147.995V145z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.5 137a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
  fill: "#fff"
})));

var _ref176 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M73.992 135A1.99 1.99 0 0072 136.998V143h11v-8z",
  fill: "#f7fafc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.5 142.5h10v-7h-8.508a1.49 1.49 0 00-1.492 1.498z",
  fill: "none",
  stroke: "#e6e9ed"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82 142v8h9.008A1.99 1.99 0 0093 148.002V142z",
  fill: "#f7fafc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.5 142.5v7h8.508a1.49 1.49 0 001.492-1.498V142.5z",
  fill: "none",
  stroke: "#e6e9ed"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.792 145.318l-1.153.002a.16.16 0 01-.152-.11l-.357-1.098a.16.16 0 00-.305 0l-.357 1.097a.16.16 0 01-.152.11h-1.154a.16.16 0 00-.094.29l.933.679a.16.16 0 01.058.18l-.356 1.097a.16.16 0 00.247.18l.933-.626a.16.16 0 01.188 0l.934.626a.16.16 0 00.247-.18l-.357-1.097a.16.16 0 01.058-.18l.933-.678a.16.16 0 00.06-.18.163.163 0 00-.154-.112z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.747 138.347l-1.14.002a.158.158 0 01-.15-.11l-.353-1.084a.158.158 0 00-.302 0l-.351 1.085a.158.158 0 01-.151.11h-1.14a.158.158 0 00-.093.287l.921.67a.158.158 0 01.058.178l-.352 1.084a.158.158 0 00.245.177l.921-.619a.158.158 0 01.186 0l.923.619a.158.158 0 00.244-.177l-.353-1.086a.158.158 0 01.058-.178l.922-.67a.158.158 0 00.058-.178.16.16 0 00-.15-.111zM72 143v4.994A2.004 2.004 0 0073.992 150H83v-7z",
  fill: "#217ab7"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M82 135v8h11v-6.002A2 2 0 0091.008 135z",
  fill: "#e25950"
})));

var _ref177 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M105.006 135a2 2 0 00-2.006 1.992v11.016a1.992 1.992 0 002.006 1.992H110v-15zM117 135v15h4.994a2 2 0 002.006-1.992v-11.016a1.992 1.992 0 00-2.006-1.992z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M110 135h7v15h-7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M110 150v-1.001h7v1zm0-14v-1h7v1z"
})));

var _ref178 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M155 136.992a2 2 0 00-1.995-1.992h-17.01a1.979 1.979 0 00-1.302.495l19.615 14.01a1.978 1.978 0 00.692-1.497z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.693 135.495a1.978 1.978 0 00-.693 1.497v11.016a2 2 0 001.995 1.992h17.01a1.979 1.979 0 001.303-.495z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.5 143a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
  fill: "#fff",
  fillOpacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.5 145a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
  fill: "#fff",
  fillOpacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.5 144a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
  fill: "#fff",
  fillOpacity: 0.9
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "path-121",
  d: "M138.5 147a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
  fill: "#fff",
  fillOpacity: 0.9
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.5 141a.5.5 0 01.5.5.5.5 0 01-.5.5.5.5 0 01-.5-.5.5.5 0 01.5-.5z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149 139v-1.292c0-.557.353-.75.804-.418l2.892 2.12c.444.326.356.59-.195.59H150v1.506c0 .536-.35.721-.784.384l-2.932-2.28c-.43-.335-.337-.61.215-.61z",
  fill: "#fac92e"
})));

var _ref179 = /*#__PURE__*/React.createElement("path", {
  d: "M166.418 135.096L176 142.5l-9.582 7.404A1.994 1.994 0 01165 148v-11a1.994 1.994 0 011.418-1.904z",
  fill: "#f6f9fc"
});

var _ref180 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M184 150h-17a1.982 1.982 0 01-1.291-.484L176 142.5l-.733-.5H186v6a2 2 0 01-2 2z",
  fill: "#e25950"
});

var _ref181 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M165.709 135.484A1.982 1.982 0 01167 135h17a2 2 0 012 2v5.5h-10z",
  fill: "#555abf"
});

var _ref182 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M169.507 140a2.502 2.502 0 11-2.493 2.5 2.496 2.496 0 012.493-2.5z",
  fill: "#f5be58"
});

var _ref183 = /*#__PURE__*/React.createElement("path", {
  d: "M198 135h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2v-11a2 2 0 012-2z",
  fill: "#f6f9fc"
});

var _ref184 = /*#__PURE__*/React.createElement("path", {
  d: "M202 135v15h13.008a1.993 1.993 0 001.992-1.992v-11.016a1.993 1.993 0 00-1.992-1.992z",
  fill: "#24b47e"
});

var _ref185 = /*#__PURE__*/React.createElement("path", {
  d: "M208.937 137a4.206 4.206 0 00-2.071 3.566 4.488 4.488 0 004.664 4.29 4.946 4.946 0 002.47-.65 4.73 4.73 0 01-4.253 2.794 4.898 4.898 0 01-4.747-5.037 4.962 4.962 0 013.937-4.963z",
  fill: "#fff"
});

var _ref186 = /*#__PURE__*/React.createElement("circle", {
  cx: 212,
  cy: 140,
  r: 1,
  fill: "#fff"
});

var _ref187 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M228 135.89h19v6.354h-19z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M227.5 142.5h20v-5.502a1.502 1.502 0 00-1.495-1.498h-17.01a1.491 1.491 0 00-1.495 1.498z",
  fill: "none",
  stroke: "#dfe5eb"
}), /*#__PURE__*/React.createElement("path", {
  d: "M227 142v6.002a2.002 2.002 0 001.995 1.998h17.01a1.991 1.991 0 001.995-1.998V142z",
  fill: "#e25950"
})));

var _ref188 = /*#__PURE__*/React.createElement("path", {
  d: "M260 135a2 2 0 00-2 2v3h21v-3a2 2 0 00-2-2z",
  fill: "#e25950"
});

var _ref189 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M258 140h21v5h-21z"
});

var _ref190 = /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M278 140h1v5h-1z"
});

var _ref191 = /*#__PURE__*/React.createElement("path", {
  d: "M258 145v3a2 2 0 002 2h17a2 2 0 002-2v-3z",
  fill: "#e25950"
});

var _ref192 = /*#__PURE__*/React.createElement("path", {
  d: "M260 150l8-7.5-8-7.5a2 2 0 00-2 2v11a2 2 0 002 2z",
  fill: "#555abf"
});

var _ref193 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M261.5 140.29l.65 1.32 1.45.21-1.05 1.02.25 1.45-1.3-.68-1.3.68.25-1.45-1.05-1.02 1.45-.21.65-1.32z"
});

var _ref194 = /*#__PURE__*/React.createElement("path", {
  d: "M291 135a2 2 0 00-2 2v3h21v-3a2 2 0 00-2-2z"
});

var _ref195 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M289 140h21v5h-21z"
});

var _ref196 = /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M309 140h1v5h-1z"
});

var _ref197 = /*#__PURE__*/React.createElement("path", {
  d: "M289 145v3a2 2 0 002 2h17a2 2 0 002-2v-3z",
  fill: "#0a9362"
});

var _ref198 = /*#__PURE__*/React.createElement("path", {
  d: "M291 150l8-7.5-8-7.5a2 2 0 00-2 2v11a2 2 0 002 2z",
  fill: "#e25950"
});

var _ref199 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M328 150h-6a2 2 0 01-2-2v-11a2 2 0 012-2h6z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M339 150h-12v-15h12a2 2 0 012 2v11a2 2 0 01-2 2z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M330.003 142.5a3.531 3.531 0 100 .001z",
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  d: "M326.425 140.001a2.5 2.5 0 11-2.424 2.574L324 142.5a2.5 2.5 0 012.425-2.499z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M325.5 141h2v2.031a1 1 0 01-2 0z",
  fill: "#f6f9fc"
})));

var _ref200 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M352.995 135a1.997 1.997 0 00-1.995 2.005V140h21v-2.995a2.006 2.006 0 00-1.995-2.005z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M351 140h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M351 145v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V145z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M361.5 144a1.5 1.5 0 111.5-1.5 1.502 1.502 0 01-1.5 1.5zm0-2a.5.5 0 10.5.5.5.5 0 00-.5-.5z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M351 140h1.001v5H351zm19.999 0H372v5h-1.001z"
})));

var _ref201 = /*#__PURE__*/React.createElement("path", {
  d: "M384 135h17a2 2 0 012 2v11a2 2 0 01-2 2h-17a2 2 0 01-2-2v-11a2 2 0 012-2z",
  fill: "#f6f9fc"
});

var _ref202 = /*#__PURE__*/React.createElement("path", {
  d: "M391 150h-2l-1-.5 2-1-2-1 2-1-2-1 2-1-2-1 2-1-2-1 2-1-2-1 2-1-2-1 2-1-2-1 1-.5h11.991a2.002 2.002 0 012.009 1.992v11.016a2.001 2.001 0 01-2.009 1.992z",
  fill: "#b1372f"
});

var _ref203 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#6772E5",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M432 150h-15.567l6.957-15H432a2 2 0 012 2v11a2 2 0 01-2 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M417.438 150H415a2 2 0 01-2-2v-11a2 2 0 012-2h11.098l-8.66 15z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M420 146l6.856-1.453V139L420 140.453z"
}));

var _ref204 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M446.006 135a2 2 0 00-2.006 1.992v11.016a1.992 1.992 0 002.006 1.992H451v-15z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M458 135v15h4.994a2 2 0 002.006-1.992v-11.016a1.992 1.992 0 00-2.006-1.992z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-295",
  fill: "#fcd669",
  d: "M451 135h7v15h-7z"
})));

var _ref205 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M476.995 135a1.999 1.999 0 00-1.995 1.998V141h21v-4.002a2.002 2.002 0 00-1.995-1.998z",
  fill: "#f6f9fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.5 140.5h20v-3.502a1.502 1.502 0 00-1.495-1.498h-17.01a1.499 1.499 0 00-1.495 1.498z",
  fill: "none",
  stroke: "#dfe5eb"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43458b",
  d: "M475 140h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M475 145v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V145z",
  fill: "#e25950"
})));

var _ref206 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M507.995 135a1.993 1.993 0 00-1.995 2.006V142h21v-4.994a2.006 2.006 0 00-1.995-2.006z",
  fill: "#45b2e8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcd669",
  d: "M506 142h21v4h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M506 146v2a2.003 2.003 0 001.995 2h17.01a1.992 1.992 0 001.995-2v-2z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 523.5,
  cy: 138.5,
  r: 1.5,
  fill: "#fcd669"
})));

var _ref207 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  rx: 2,
  ry: 2,
  fill: "#24b47e",
  x: 10,
  y: 160
}), /*#__PURE__*/React.createElement("path", {
  d: "M25 170h1l-.5 1H25v1l-1-.5v-.5h-6.508L15 170h9v-.5l1-.5z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-584",
  fill: "#fff",
  d: "M24 164l1.657.146L26 165v2h-1l-1.492-.528L23 167v-3h1zm-3.283.375L22 164v3l-1.283-.488L19 167l.172-1.858L19 164l1.717.375zM17 164l1 1v2l-.764-.343L16 167l-.994-.006.183-2.917L17 164z"
})));

var _ref208 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43 160h17a2 2 0 012 2v11a2 2 0 01-2 2H43a2 2 0 01-2-2v-11a2 2 0 012-2z",
  fill: "#217ab7"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  fill: "#fcd669",
  d: "M62 169H50v6h-3v-6h-6v-3h6v-6h3v6h12v3z"
})));

var _ref209 = /*#__PURE__*/React.createElement("path", {
  d: "M73.995 160A1.991 1.991 0 0072 161.998V168h21v-6.002A2.002 2.002 0 0091.005 160z",
  fill: "#ea2c3f"
});

var _ref210 = /*#__PURE__*/React.createElement("path", {
  d: "M93 167v6a2 2 0 01-2 2H74a2 2 0 01-2-2v-6z",
  fill: "#f6f9fc"
});

var _ref211 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M72 168v-6a2 2 0 012-2h17a2 2 0 012 2v6z",
  fill: "#e25950"
});

var _ref212 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M76.368 163.96a2.367 2.367 0 002.354 2.367A2.956 2.956 0 1176.96 161a2.936 2.936 0 011.762.593 2.367 2.367 0 00-2.354 2.367zm6.194.415a.594.594 0 11.57-.593.594.594 0 01-.57.593zm-1.5-1.187a.594.594 0 11.595-.593.594.594 0 01-.595.593zm-.281 2.375a.594.594 0 11-.594-.594.594.594 0 01.594.594zm-1.187-1.188a.594.594 0 11.594-.594.594.594 0 01-.594.594zm2.375.594a.593.593 0 11-.593.593.593.593 0 01.593-.593z",
  fill: "#f6f9fc"
});

var _ref213 = /*#__PURE__*/React.createElement("path", {
  d: "M105 160a2 2 0 00-2 2v3h21v-3a2 2 0 00-2-2z",
  fill: "#f6f9fc"
});

var _ref214 = /*#__PURE__*/React.createElement("path", {
  fill: "#555abf",
  d: "M103 165h21v5h-21z"
});

var _ref215 = /*#__PURE__*/React.createElement("path", {
  d: "M103 170v3a2 2 0 002 2h17a2 2 0 002-2v-3z",
  fill: "#e25950"
});

var _ref216 = /*#__PURE__*/React.createElement("path", {
  d: "M112 164v4.5a2.5 2.5 0 01-5 0V164h5m1-1h-7v5.5a3.5 3.5 0 007 0V163z",
  fill: "#e25950"
});

var _ref217 = /*#__PURE__*/React.createElement("path", {
  d: "M107 164h5v4.5a2.5 2.5 0 01-2.5 2.5 2.5 2.5 0 01-2.5-2.5V164z",
  fill: "#555abf"
});

var _ref218 = /*#__PURE__*/React.createElement("path", {
  d: "M109.5 171a2.5 2.5 0 01-2.5-2.5l1-.84.51.42.99-1.08 1 1.08.5-.41 1 .83a2.5 2.5 0 01-2.5 2.5z",
  fill: "#f6f9fc"
});

var _ref219 = /*#__PURE__*/React.createElement("circle", {
  cx: 108.5,
  cy: 165.04,
  r: 0.5,
  fill: "#f6f9fc"
});

var _ref220 = /*#__PURE__*/React.createElement("circle", {
  cx: 110.5,
  cy: 165.04,
  r: 0.5,
  fill: "#f6f9fc"
});

var _ref221 = /*#__PURE__*/React.createElement("circle", {
  cx: 109.49,
  cy: 166.17,
  r: 0.5,
  fill: "#f6f9fc"
});

var _ref222 = /*#__PURE__*/React.createElement("path", {
  d: "M122 161a1 1 0 011 1v3h1v-3a2 2 0 00-2-2h-17a2 2 0 00-2 2v3h1v-3a1 1 0 011-1h17",
  fill: "#eaeef3"
});

var _ref223 = /*#__PURE__*/React.createElement("path", {
  d: "M136 160a2 2 0 00-2 2v3h21v-3a2 2 0 00-2-2z",
  fill: "#f6f9fc"
});

var _ref224 = /*#__PURE__*/React.createElement("path", {
  fill: "#555abf",
  d: "M134 165h21v5h-21z"
});

var _ref225 = /*#__PURE__*/React.createElement("path", {
  d: "M134 170v3a2 2 0 002 2h17a2 2 0 002-2v-3z",
  fill: "#e25950"
});

var _ref226 = /*#__PURE__*/React.createElement("path", {
  d: "M137 163h7v5.5a3.5 3.5 0 01-3.5 3.5 3.5 3.5 0 01-3.5-3.5V163z",
  fill: "#f6f9fc"
});

var _ref227 = /*#__PURE__*/React.createElement("path", {
  d: "M138 164h5v4.5a2.5 2.5 0 01-2.5 2.5 2.5 2.5 0 01-2.5-2.5V164z",
  fill: "#ed1c24"
});

var _ref228 = /*#__PURE__*/React.createElement("path", {
  d: "M140.5 171a2.5 2.5 0 01-2.5-2.5h5a2.5 2.5 0 01-2.5 2.5z",
  fill: "#555abf"
});

var _ref229 = /*#__PURE__*/React.createElement("path", {
  d: "M153 161a1 1 0 011 1v3h1v-3a2 2 0 00-2-2h-17a2 2 0 00-2 2v3h1v-3a1 1 0 011-1h17",
  fill: "#eaeef3"
});

var _ref230 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M140 164.5h1v4h-1z"
});

var _ref231 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M139 165h3v1h-3zm-.5 2h4v1h-4z"
});

var _ref232 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M166.995 160a1.997 1.997 0 00-1.995 2.005V165h21v-2.995a2.006 2.006 0 00-1.995-2.005z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M165 165h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M165 170v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V170z",
  fill: "#217ab7"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M165 165h1.001v5H165zm19.999 0H186v5h-1.001z"
})));

var _ref233 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M198.006 160a2 2 0 00-2.006 1.992v11.016a1.992 1.992 0 002.006 1.992H203v-15z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210 160v15h4.994a2 2 0 002.006-1.992v-11.016a1.992 1.992 0 00-2.006-1.992z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-295",
  fill: "#fcd669",
  d: "M203 160h7v15h-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M208.796 166.667l-1.458.003a.202.202 0 01-.193-.14l-.452-1.387a.202.202 0 00-.386 0l-.45 1.386a.202.202 0 01-.193.14h-1.46a.202.202 0 00-.118.368l1.18.857a.202.202 0 01.073.228l-.45 1.387a.202.202 0 00.313.227l1.18-.791a.202.202 0 01.238 0l1.18.791a.202.202 0 00.313-.227l-.452-1.387a.202.202 0 01.074-.228l1.18-.857a.202.202 0 00.075-.227.205.205 0 00-.194-.143z",
  fill: "#24b47e"
})));

var _ref234 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  rx: 2,
  ry: 2,
  fill: "#217ab7",
  x: 227,
  y: 160
}), /*#__PURE__*/React.createElement("path", {
  d: "M241.633 166l-2.625.006a.364.364 0 01-.347-.253l-.813-2.497a.364.364 0 00-.695 0l-.811 2.496a.364.364 0 01-.347.253h-2.626a.364.364 0 00-.215.661l2.124 1.544a.364.364 0 01.132.409l-.81 2.497a.364.364 0 00.562.41l2.124-1.426a.364.364 0 01.43 0l2.125 1.425a.364.364 0 00.563-.409l-.813-2.497a.364.364 0 01.132-.41l2.125-1.543a.364.364 0 00.134-.409.37.37 0 00-.35-.257z",
  fill: "#fff"
})));

var _ref235 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M259.995 160a1.997 1.997 0 00-1.995 2.005V165h21v-2.995a2.006 2.006 0 00-1.995-2.005z",
  fill: "#555abf"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M258 165h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M258 165h1.001v5H258zm19.999 0H279v5h-1.001z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M258 170v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V170z",
  fill: "#555abf",
  "data-name": "Rectangle-34"
}), /*#__PURE__*/React.createElement("path", {
  d: "M268.5 169a1.5 1.5 0 111.5-1.5 1.502 1.502 0 01-1.5 1.5zm0-2a.5.5 0 10.5.5.5.5 0 00-.5-.5z",
  fill: "#efcf57"
})));

var _ref236 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M291.006 160a2 2 0 00-2.006 1.992v11.016a1.992 1.992 0 002.006 1.992H296v-15z",
  fill: "#43458b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M303 160v15h4.994a2 2 0 002.006-1.992v-11.016a1.992 1.992 0 00-2.006-1.992z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-295",
  fill: "#fcd669",
  d: "M296 160h7v15h-7z"
})));

var _ref237 = /*#__PURE__*/React.createElement("path", {
  d: "M341 163h-21v-1a2 2 0 012-2h17a2 2 0 012 2z",
  fill: "#e25950"
});

var _ref238 = /*#__PURE__*/React.createElement("path", {
  fill: "#f9f9f9",
  d: "M320 163h21v2h-21z"
});

var _ref239 = /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M320 163h1v2h-1z"
});

var _ref240 = /*#__PURE__*/React.createElement("path", {
  fill: "#f9f9f9",
  d: "M320 170h21v2h-21z"
});

var _ref241 = /*#__PURE__*/React.createElement("path", {
  d: "M320 172h21v1a2 2 0 01-2 2h-17a2 2 0 01-2-2z",
  fill: "#e25950"
});

var _ref242 = /*#__PURE__*/React.createElement("path", {
  fill: "#555abf",
  d: "M320 165h21v5h-21z"
});

var _ref243 = /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M320 170h1v2h-1zm20-7h1v2h-1zm0 7h1v2h-1z"
});

var _ref244 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M352.995 160a1.997 1.997 0 00-1.995 2.005V165h21v-2.995a2.006 2.006 0 00-1.995-2.005z",
  fill: "#ca0814"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M351 165h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M351 170v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V170z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M357 168.5a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2-1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2-1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm-4 0a.5.5 0 11.5.5.5.5 0 01-.5-.5z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "path-174",
  d: "M357 168.5a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2-1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2-1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm-4 0a.5.5 0 11.5.5.5.5 0 01-.5-.5z",
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M351 165h1.001v5H351zm19.999 0H372v5h-1.001z"
})));

var _ref245 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M401 160h-17a1.99 1.99 0 00-1.438.615.813.813 0 01.205.116l.643.528L395 167.5l-11.59 6.241-.642.528a.813.813 0 01-.206.116A1.99 1.99 0 00384 175h17a2 2 0 002-2v-11a2 2 0 00-2-2z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcd669",
  d: "M383.41 173.741L395 167.5l-11.59-6.241L391 167.5l-7.59 6.241z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.873 160.97l.537.289-.643-.528a.813.813 0 00-.206-.116 2.008 2.008 0 00-.238.301.623.623 0 01.55.054zm.537 12.771l-.537.289a.623.623 0 01-.55.054 1.998 1.998 0 00.239.3.813.813 0 00.205-.115z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.873 174.03l.537-.289L391 167.5l-7.59-6.241-.537-.289a.623.623 0 00-.55-.054A1.987 1.987 0 00382 162v11a1.986 1.986 0 00.323 1.084.623.623 0 00.55-.054zM385.5 166a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 385.5,
  cy: 167.5,
  r: 1.5,
  fill: "#f7fafc"
})));

var _ref246 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  rx: 2,
  ry: 2,
  fill: "#e25950",
  x: 413,
  y: 160
}), /*#__PURE__*/React.createElement("path", {
  d: "M422.431 163.096a4.403 4.403 0 00-3.431 4.251 4.426 4.426 0 004.104 4.359 4.5 4.5 0 11-.673-8.61z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 424.5,
  cy: 167.5,
  r: 1.5,
  fill: "#fff"
})));

var _ref247 = /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  rx: 2,
  fill: "#e25950",
  x: 444,
  y: 160
});

var _ref248 = /*#__PURE__*/React.createElement("path", {
  d: "M446 160h7v9h-9v-7a2 2 0 012-2z",
  fill: "#555abf"
});

var _ref249 = /*#__PURE__*/React.createElement("circle", {
  cx: 448.5,
  cy: 164.5,
  r: 2.5,
  fill: "#fff"
});

var _ref250 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fcd669",
  d: "M481 175l15-10v-2l-18 12h3zm9-15l-15 10v2l18-12h-3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M478 160h-1.008a1.99 1.99 0 00-1.992 2v8l15-10z",
  fill: "#24b47e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M481 175h13.008a1.997 1.997 0 001.992-2v-8z",
  fill: "#45b2e8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M494 160h-1l-18 12v1a2 2 0 002 2h1l18-12v-1a2 2 0 00-2-2z"
})));

var _ref251 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M507.995 160a1.991 1.991 0 00-1.995 1.998V168h21v-6.002a2.002 2.002 0 00-1.995-1.998z",
  fill: "#45b2e8"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-295",
  d: "M506 168v4.994a2.006 2.006 0 001.995 2.006h17.01a1.993 1.993 0 001.995-2.006V168z",
  fill: "#fcd669"
})));

var _ref252 = /*#__PURE__*/React.createElement("path", {
  d: "M29 200H12a2 2 0 01-2-2v-7h8v-6h11a2 2 0 012 2v11a2 2 0 01-2 2z",
  fill: "#e25950"
});

var _ref253 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M10 196h21v1H10zm0-2h21v1H10zm0-2h21v1H10zm8-2h13v1H18zm0-2h13v1H18zm0-2h12.723a1.987 1.987 0 01.277 1H18zm12.723 13H10.277a1.986 1.986 0 01-.277-1h21a1.987 1.987 0 01-.277 1z",
  fill: "#f6f9fc"
});

var _ref254 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M10 192v-5a2 2 0 012-2h7v7z",
  fill: "#43458b"
});

var _ref255 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M17.73 187.408a.703.703 0 11.676-.703.703.703 0 01-.676.703zm-.297 1.297a.704.704 0 11-.704-.705.704.704 0 01.704.704zm-1.703-1.297a.704.704 0 11.677-.704.704.704 0 01-.677.704zm-.297 1.297a.704.704 0 11-.704-.705.704.704 0 01.704.704zm-1.703-1.297a.704.704 0 11.677-.704.704.704 0 01-.677.704zm-.297 1.297a.704.704 0 11-.704-.705.704.704 0 01.704.704zm-1.703-1.297a.703.703 0 11.676-.703.703.703 0 01-.676.703zm0 2.592a.704.704 0 11-.678.703.704.704 0 01.678-.703zm2 0a.704.704 0 11-.678.703.704.704 0 01.678-.703zm2 0a.704.704 0 11-.678.703.704.704 0 01.678-.703zm2 0a.704.704 0 11-.678.703.704.704 0 01.678-.703z",
  fill: "#fff"
});

var _ref256 = /*#__PURE__*/React.createElement("path", {
  d: "M51 185h9a2 2 0 012 2v11H51v-13z",
  fill: "#f6f9fc"
});

var _ref257 = /*#__PURE__*/React.createElement("path", {
  fill: "#012b7f",
  d: "M42 197h19v2H42z"
});

var _ref258 = /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M61 186.5h1v11h-1z"
});

var _ref259 = /*#__PURE__*/React.createElement("path", {
  d: "M43 185h8v12H41v-10a2 2 0 012-2z",
  fill: "#f6f9fc"
});

var _ref260 = /*#__PURE__*/React.createElement("circle", {
  cx: 45.5,
  cy: 189.5,
  r: 2.5,
  fill: "#fcd669"
});

var _ref261 = /*#__PURE__*/React.createElement("path", {
  fill: "#012b7f",
  d: "M42 193.33h19v2H42zm8-3.66h11v2H50zm0-3.67h9.93a1.07 1.07 0 011.07 1.07v.93H50v-2z"
});

var _ref262 = /*#__PURE__*/React.createElement("g", {
  fill: "#eaeef3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41 188h1v10h-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60 186a1 1 0 011 1v3h1v-3a2 2 0 00-2-2H43a2 2 0 00-2 2v3h1v-3a1 1 0 011-1h17m0 13a1 1 0 001-1v-3h1v3a2 2 0 01-2 2H43a2 2 0 01-2-2v-3h1v3a1 1 0 001 1h17"
}));

var _ref263 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M73.995 185A1.997 1.997 0 0072 187.005V190h21v-2.995A2.006 2.006 0 0091.005 185z",
  fill: "#fcd669"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72 195v2.995A2.006 2.006 0 0073.995 200h17.01A1.997 1.997 0 0093 197.995V195z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43458b",
  d: "M72 190h21v6H72z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78 194.5a.5.5 0 11.5.5.5.5 0 01-.5-.5zm1-2a.5.5 0 11.5.5.5.5 0 01-.5-.5zm3-1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm3 1a.5.5 0 11.5.5.5.5 0 01-.5-.5zm1 2a.5.5 0 11.5.5.5.5 0 01-.5-.5z",
  fill: "#fff"
})));

var _ref264 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 15,
  rx: 2,
  ry: 2,
  fill: "#e25950",
  x: 103,
  y: 185
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.633 191l-2.625.006a.364.364 0 01-.347-.253l-.813-2.497a.364.364 0 00-.695 0l-.811 2.496a.364.364 0 01-.347.253h-2.626a.364.364 0 00-.215.661l2.124 1.544a.364.364 0 01.132.409l-.81 2.497a.364.364 0 00.562.41l2.124-1.426a.364.364 0 01.43 0l2.125 1.425a.364.364 0 00.563-.409l-.813-2.497a.364.364 0 01.132-.41l2.125-1.543a.364.364 0 00.134-.409.37.37 0 00-.35-.257z",
  fill: "#fcd669"
})));

var _ref265 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M153 200h-11.098l8.66-15H153a2 2 0 012 2v11a2 2 0 01-2 2zm-14.562 0H136a2 2 0 01-2-2v-11a2 2 0 012-2h11.098z",
  "data-name": "Layer 1"
}));

var _ref266 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M166.995 185a1.997 1.997 0 00-1.995 2.005V190h21v-2.995a2.006 2.006 0 00-1.995-2.005z",
  fill: "#e25950"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M165 190h21v5h-21z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle-34",
  d: "M165 195v2.995a2.006 2.006 0 001.995 2.005h17.01a1.997 1.997 0 001.995-2.005V195z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eaeef3",
  d: "M165 190h1.001v5H165zm19.999 0H186v5h-1.001z"
})));

var _ref267 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f9fc",
  d: "M199 185h18v15h-18z"
});

var _ref268 = /*#__PURE__*/React.createElement("path", {
  d: "M206.24 189.25H217V187a2 2 0 00-2-2h-14.71z",
  fill: "#e25950"
});

var _ref269 = /*#__PURE__*/React.createElement("path", {
  d: "M200.29 200H215a2 2 0 002-2v-2.25h-10.76z",
  fill: "#012b7f"
});

var _ref270 = /*#__PURE__*/React.createElement("path", {
  d: "M217 195h-11l-7 5h-1a2 2 0 01-2-2v-11a2 2 0 012-2h1l7 5h11z",
  fill: "#24b47e"
});

var _ref271 = /*#__PURE__*/React.createElement("path", {
  d: "M196 197v-9l6.5 4.5-6.5 4.5z"
});

var _ref272 = /*#__PURE__*/React.createElement("path", {
  fill: "#fcd669",
  d: "M196.43 187.38l-.43-.29v.91l6.5 4.5-6.5 4.5v.91l.43-.29 6.5-4.5.89-.62-.89-.62-6.5-4.5z"
});

function SvgFlagIcons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 537,
    height: 210
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref13, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M398 11h-11v-1h11zm-11 13h11v1h-11z",
    fill: "#e25950",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _ref14)), _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref28, /*#__PURE__*/React.createElement("path", {
    d: "M134.665 49.48a1.991 1.991 0 00.596.375 1.998 1.998 0 01-.595-.375z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ref29, /*#__PURE__*/React.createElement("path", {
    d: "M153 35h-17a1.982 1.982 0 00-1.29.484.788.788 0 01.135.054l.83.528A.981.981 0 01136 36h17a1 1 0 011 1v5h1v-5a2 2 0 00-2-2z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ref30, _ref31, _ref32, _ref33)), _ref34, _ref35, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref36, _ref37, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M247 45v-5h1v5zm-15 4h5v1h-5zm0-14h5v1h-5zm-5 5h1v5h-1z",
    fill: "#e25950",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref38, _ref39, _ref40, _ref41, _ref42, /*#__PURE__*/React.createElement("path", {
    d: "M277 36a1 1 0 011 1v11a1 1 0 01-1 1h-9v1h9a2 2 0 002-2V37a2 2 0 00-2-2h-9v1z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }))), _ref43, _ref44, _ref45, _ref46, _ref47, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref48, _ref49, /*#__PURE__*/React.createElement("path", {
    d: "M339 50h-17a2 2 0 01-2-2v-6h1v6a1 1 0 001 1h17a1 1 0 001-1v-6h1v6a2 2 0 01-2 2z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ref50)), _ref51, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref52, _ref53, _ref54, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M387 45a2 2 0 01-2-2v-.5h2z",
    fill: "#e25950",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _ref55)), _ref56, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref57, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M463 50h-17a2 2 0 01-2-2V37a2 2 0 012-2h17a2 2 0 012 2v11a2 2 0 01-2 2zm1-13a1 1 0 00-1-1h-17a1 1 0 00-1 1v11a1 1 0 001 1h17a1 1 0 001-1z",
    fill: "#8898aa",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }), _ref58)), _ref59, _ref60, _ref61, _ref62, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref63, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M512 50v-1h9v1zm0-15h9v1h-9z",
    fill: "#8898aa",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _ref64, _ref65)), _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref95, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M388 75v-1h9v1zm0-15h9v1h-9z",
    fill: "#8898aa",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _ref96, _ref97)), _ref98, _ref99, _ref100, _ref101, _ref102, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref103, _ref104, _ref105, _ref106, /*#__PURE__*/React.createElement("path", {
    d: "M11 88.5a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle-962",
    d: "M11 96.5a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5zm2 0a.5.5 0 11.5.5.5.5 0 01-.5-.5z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _ref107)), _ref108, _ref109, _ref110, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref111, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M78 100v-1h9v1zm0-15h9v1h-9z",
    fill: "#8898aa",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _ref112, _ref113)), _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref120, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M215 100h-17a2 2 0 01-2-2V87a2 2 0 012-2h17a2 2 0 012 2v11a2 2 0 01-2 2zm1-13a1 1 0 00-1-1h-17a1 1 0 00-1 1v11a1 1 0 001 1h17a1 1 0 001-1z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ref121)), _ref122, _ref123, _ref124, _ref125, _ref126, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref127, _ref128, /*#__PURE__*/React.createElement("path", {
    fill: "#047a9d",
    fillOpacity: 0.199,
    opacity: 0.78,
    style: {
      isolation: "isolate"
    },
    d: "M383 88h4v9h-4z"
  }), _ref129)), _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref137, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M61 121v-7h1v7zm-20-7h1v7h-1z",
    fill: "#8898aa",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _ref138, _ref139)), _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref146, /*#__PURE__*/React.createElement("path", {
    d: "M136 111a1 1 0 00-1 1v11a1 1 0 001 1h9v1h-9a2 2 0 01-2-2v-11a2 2 0 012-2h9v1z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ref147, _ref148)), _ref149, _ref150, _ref151, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277 125h-17a2 2 0 01-2-2v-11a2 2 0 012-2h17a2 2 0 012 2v11a2 2 0 01-2 2zm1-13a1 1 0 00-1-1h-17a1 1 0 00-1 1v11a1 1 0 001 1h17a1 1 0 001-1z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ref152, _ref153)), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref154, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M295 125v-1h9v1zm0-15h9v1h-9z",
    fill: "#8898aa",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _ref155, _ref156, _ref157, _ref158)), _ref159, _ref160, /*#__PURE__*/React.createElement("path", {
    d: "M339 125h-17a2 2 0 01-2-2v-7h1v7a1 1 0 001 1h17a1 1 0 001-1v-11a1 1 0 00-1-1h-11v-1h11a2 2 0 012 2v11a2 2 0 01-2 2z",
    style: {
      isolation: "isolate"
    },
    fill: "#e25950",
    opacity: 0.2
  }), _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref168, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M495 121v-7h1v7zm-20-7h1v7h-1z",
    fill: "#8898aa",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _ref169, _ref170)), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref171, _ref172, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M526 119v-3h1v3zm-14 5h3v1h-3zm0-14h3v1h-3zm-6 6h1v3h-1z",
    fill: "#555abf",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _ref173)), _ref174, _ref175, _ref176, _ref177, _ref178, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref179, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M167 136a1 1 0 00-1 1v11a1 1 0 001 1h1v1h-1a2 2 0 01-2-2v-11a2 2 0 012-2h1v1z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ref180, _ref181, _ref182)), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref183, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M215 150h-17a2 2 0 01-2-2v-11a2 2 0 012-2h17a2 2 0 012 2v11a2 2 0 01-2 2zm1-13a1 1 0 00-1-1h-17a1 1 0 00-1 1v11a1 1 0 001 1h17a1 1 0 001-1z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ref184, _ref185, _ref186)), _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref201, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M401 150h-17a2 2 0 01-2-2v-11a2 2 0 012-2h17a2 2 0 012 2v11a2 2 0 01-2 2zm1-13a1 1 0 00-1-1h-17a1 1 0 00-1 1v11a1 1 0 001 1h17a1 1 0 001-1z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ref202)), _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref209, _ref210, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M91 175H74a2 2 0 01-2-2v-6h1v6a1 1 0 001 1h17a1 1 0 001-1v-6h1v6a2 2 0 01-2 2z",
    fill: "#8898aa",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ref211, _ref212)), _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245, _ref246, _ref247, _ref248, _ref249, _ref250, _ref251, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref252, _ref253, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M29 200H12a2 2 0 01-2-2v-7h1v7a1 1 0 001 1h17a1 1 0 001-1v-11a1 1 0 00-1-1H18v-1h11a2 2 0 012 2v11a2 2 0 01-2 2z",
    fill: "#e25950",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _ref254, _ref255, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M19 189.21a.703.703 0 110-1.011zm-9-.975a.697.697 0 011.219.47.703.703 0 01-.703.703.694.694 0 01-.516-.234z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }))), _ref256, _ref257, _ref258, _ref259, _ref260, _ref261, _ref262, _ref263, _ref264, _ref265, _ref266, _ref267, _ref268, _ref269, _ref270, _ref271, _ref272);
}

export default __webpack_public_path__ + "static/flagIcons.f6fa52df.svg";
export { SvgFlagIcons as ReactComponent };